import { render, staticRenderFns } from "./OutList.vue?vue&type=template&id=2b5b2cb3"
import script from "./OutList.vue?vue&type=script&lang=js"
export * from "./OutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports